// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aZCv","colBig":"styles_colBig__2u8Sa","colSmall":"styles_colSmall__3mYwA"};